export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const fileData = node.data.fileData || ''
  const genericTemplateTitle = node.data.genericTemplateTitle || ''
  const genericTemplateSubtitle = node.data.genericTemplateSubtitle || ''
  const imageClickDestinationLink = node.data.imageClickDestinationLink || ''

  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  let html = ''

  if (Object.values(fileData).length === 3) {
    const filePath = fileData.path || ''
    const fileName = fileData.filename || ''

    if (filePath && fileName) {
      const imgSource = 'https://192.168.10.60/xerochat/' + filePath + fileName
      if (imageClickDestinationLink) {
        html += `<p><img class="img-fluid" src="${imgSource}" /></p>`
      } else {
        html += `<p><a href="${imageClickDestinationLink}" target="_blank"><img class="img-fluid" src="${imgSource}" /></a></p>`
      }
    }
  }
  
  if (genericTemplateTitle) {
    html += `<p><strong>Title:</strong> ${genericTemplateTitle}</p>`
  }
  
  if (genericTemplateSubtitle) {
    html += `<p><strong>Subtitle:</strong> ${genericTemplateSubtitle}</p>`
  }

  if (IsTypingOnDisplayChecked && delayReplyFor) {
    html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
  }   

  if (! genericTemplateTitle && ! genericTemplateSubtitle) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }
}